import React from "react";

function AddProjectButton({ className }: { className: string }) {
  return (
    <svg className={className} viewBox="0 0 28.19 21.277">
      <path
        d="M18.36,42.583H11.732a1,1,0,0,1-.713-.3L8.951,40.106a2.621,2.621,0,0,0-1.866-.75H2.58A2.583,2.583,0,0,0,0,41.936V54.5a2.583,2.583,0,0,0,2.58,2.58H18.372a2.583,2.583,0,0,0,2.568-2.588V45.163A2.583,2.583,0,0,0,18.36,42.583Zm1,11.909a1,1,0,0,1-.994,1.007H2.58a1,1,0,0,1-1-1V41.936a1,1,0,0,1,1-1H7.132a1,1,0,0,1,.691.275L9.88,43.377a2.592,2.592,0,0,0,1.853.784H18.36a1,1,0,0,1,1,1v9.329Z"
        transform="translate(0 -39.356)"
      />
      <path
        d="M7.5,0A7.5,7.5,0,1,1,0,7.5,7.5,7.5,0,0,1,7.5,0Z"
        transform="translate(13.195 5.916)"
      />
      <text
        transform="translate(16.748 17.277)"
        fill="#333"
        fontSize="14"
        fontFamily="Quicksand-Medium, Quicksand"
        fontWeight="500"
        letterSpacing="-0.024em"
      >
        <tspan x="0" y="1">
          +
        </tspan>
      </text>
    </svg>
  );
}

export { AddProjectButton };
